mainApp.directive('monitorRealtime', function() {
    return {
        templateUrl: '/public/directives/monitorRealtime.html',
        scope: {
            type: '=',
            finishedLoading: '=?',
            options: '=?',
            item: '=?',
            pid: '=?',
        },
        controller: ['$scope', '$interval', '$timeout', '$state', '$filter', '$sce', '$element', 'ChartsService', 'GeneralUtilsService', 'IntervalService', function($scope, $interval, $timeout, $state, $filter, $sce, $element, ChartsService, GeneralUtilsService, IntervalService) {
            // set the root realtime as true, to hide the date picker selector in index
            $scope.$root.realtime = true;
            $scope.options = $scope.options || {};
            $scope.innerLoader = true;

            var MAX_CHART_ITEMS_COUNT = 60;
            var TIME_DELAY = 10000;
            var MAX_DATA_COLLECTIONS_SIZE = 80;
            var MAX_SEPARATED_GRAPHS = 4;
            var MAX_TOPS_TO_SHOW = 10;
            var GRAPHS_COLORS = ChartsService.graphColors;
            var MERGED_LINE_COLOR = "#42bef7";

            var usedGraphsColors = [];
            var runTimeout, updateViewLoop;
            var qosChart1, qosChart2, transportChart1, transportChart2;
            var allData;
            var chartData = [];
            var hostsCharts = [];
            var appsCharts = [];
            var graphs = {};
            var currentTimestamp;
            var $topsBalloon = null;
            var priorities = [];
            var transports = [];
            var handleVisibilityChange;
            var stop = false;
            var globalDate, formerDate;
            var allItemsId = -1;
            var shouldUpdateView = false; //flag to tell update view loop to update view

            var firstRequest = true;
            var dataStatus = 'NOT_SET';
            var updateSystemInfoCounter = 0;
            var $thisElement;

            $scope.graph_modes = { merged: 'merged', separated: 'separated', stacked: 'stacked' };
            $scope.currentGraphsMode = $scope.graph_modes.merged;
            $scope.rules = {};
            $scope.paused = false;
            $scope.isSystemLogin = isSystemLogin;
            $scope.currentData = {};

            $scope.directions = [
                { value: 'upstream', label: 'Upstream', modifier: 1 },
                { value: 'downstream', label: 'Downstream', modifier: -1 }
            ];


            var commonViewTableSettings = {
                dataURL: function() {
                    return null;
                },
                pageSize: 255,
                fixedLayout: true,
                parseData: function() {
                    return this.tableItems;
                },
                stopPropagation: function($event) {
                    $event.stopPropagation();
                },
                toggleItem: function(item, $event) {
                    $event.stopPropagation();
                    var that = this;
                    // checking if all items are selected
                    if (that.currentItems.indexOf(allItemsId) >= 0) {
                        that.currentItems.length = 0;
                        that.tableItems.forEach(function(tableItem) {
                            if (tableItem.id === item.id) {
                                item.selected = false;
                            } else {
                                that.selectItem(tableItem);
                            }
                        });
                    } else {
                        if (that.currentItems.indexOf(item.id) >= 0) {
                            unSelectItem(item);
                        } else {
                            if (that.currentItems.length >= MAX_SEPARATED_GRAPHS && $scope.currentGraphsMode !== $scope.graph_modes.merged) {
                                $scope.$root.alert('Max number of selected items is ' + MAX_SEPARATED_GRAPHS + '. Please adjust your selection.');
                                return;
                            } else {
                                that.selectItem(item);
                            }
                        }
                    }
                    changeView();
                },
                selectItem: function(item) {
                    if ($scope.currentGraphsMode === $scope.graph_modes.merged) {
                        item.color = MERGED_LINE_COLOR;
                    } else {
                        item.color = getItemColor(item);
                        $scope.currentView.updateGraphs(item.id + '_', item.name, item.color, item ? item.destType : null, item ? item.type : null);
                    }

                    item.selected = true;
                    this.currentItems.push(item.id);
                },
                selectOnlyItem: function(item, $event) {
                    $event.stopPropagation();

                    this.tableItems.forEach(function(tableItem) {
                        if (tableItem !== item) {
                            unSelectItem(tableItem);
                        }
                    });
                    if (!item.selected) {
                        this.selectItem(item);
                    }
                    changeView();
                },
                toggleAll: function() {
                    var that = this;

                    if (that.currentItems.length > 0) {
                        that.tableItems.forEach(function(tableItem) {
                            tableItem.selected = false;
                        });
                        that.currentItems.length = 0;
                    } else {
                        that.tableItems.forEach(function(tableItem) {
                            tableItem.color = MERGED_LINE_COLOR;
                            tableItem.selected = true;
                            that.currentItems.push(tableItem.id);
                        });
                    }

                    changeView();
                },
                hideCheckboxes: true,
                innerRow:  {path: 'innerRow', template: '<tops-list item="item"></tops-list>' },
                expandRow: function() {return true},
                clientSideSearch: true,
                noAutoSelect: true,
                afterUpdate: function() {
                    var that = this;
                    $timeout(function() {
                        drawTopCharts(that.tableItems, 'hosts', hostsCharts);
                        drawTopCharts(that.tableItems, 'apps', appsCharts);
                    }, 0, false);
                },
                preFields: [{
                    template: '<div class="graph-display" ng-mouseenter="hovering = true" ng-mouseleave="hovering = false" ng-init="hovering = false;"> ' +
                    '<div ng-click="tableConfig.toggleItem(item, $event)" class="prio-btn" data-toggle="tooltip" ng-attr-title="Toggle {{tableConfig.type}}" data-animation="false"> ' +
                    '<div ng-show="(item.selected && !hovering) || (!item.selected && hovering)"><svg class="icon icon-eye-open"<!-- style="color:{{item.color}}"-->> ' +
                    '<use xlink:href="/public/images/icons/main.svg#icon-eye-open"></use></svg></div><div ng-show="(!item.selected && !hovering) || (item.selected &&  ' +
                    'hovering)"><svg class="icon icon-eye-closed"><use xlink:href="/public/images/icons/main.svg#icon-eye-closed"></use></svg></div></div><div  ' +
                    'ng-click="tableConfig.selectOnlyItem(item, $event)" class="prio-btn prio-btn-1" data-toggle="tooltip" ng-attr-title="Show Only This {{tableConfig.type}}"  ' +
                    'data-animation="false"><svg class="icon icon-eye-plus"><use xlink:href="/public/images/icons/main.svg#icon-eye-plus"></use></svg></div></div>',
                    specialHeader: {
                        template: '<div ng-click="tableConfig.toggleAll()"  ng-show="tableConfig.currentItems && tableConfig.showToggleAll()" class="prio-btn all" data-toggle="tooltip" ng-attr-title="Toggle {{tableConfig.type}}" data-animation="false">' +
                        '<div ng-show="tableConfig.currentItems.length == 0"><svg class="icon icon-eye-open"><use xlink:href="/public/images/icons/main.svg#icon-eye-open"></use></svg></div>' +
                        '<div ng-show="tableConfig.currentItems.length > 0"><svg class="icon icon-eye-closed"><use xlink:href="/public/images/icons/main.svg#icon-eye-closed"></use></svg></div></div>',
                        path: '',
                        label: 'toggle-header'
                    },
                    labelType: 'html',
                    noSort: true,
                    path: '',
                    label: 'toggle',
                }],
                showToggleAll: function() {
                    return $scope.currentGraphsMode === $scope.graph_modes.merged;
                },
                noSort: true,
            };

            $scope.views = {
                priorities: {
                    interval: 1000,
                    order: 0,
                    title: 'QoS',
                    mergeTransports: true,
                    mergePriorities: false,
                    charts: [
                        { id: 'qosChart1', position: 'right', minxMax: true },
                        { id: 'qosChart2', small: true, position: 'right', minxMax: true },
                    ],
                    statsCollection: 'ratesDataPoints',
                    currentsCollection: 'ratesDataPoints',
                    timeInterval: 1000,
                    drawCharts: function() {
                        var chartsSettings1 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-1', 'Throughput', function(value) {
                                    return $filter('bits')(Math.abs(value), 1) + 'ps';
                                }),
                                { id: 'ValueAxis-3', "gridAlpha": 0, "axisAlpha": 0, "stackType": "regular", "labelsEnabled": false }
                            ],
                        });

                        this.charts[0].chart = AmCharts.makeChart(this.charts[0].id, chartsSettings1);

                        var chartsSettings2 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-2', 'Discarded Packets', function(value) {
                                    return $filter('bits')(Math.abs(value), 1);
                                })
                            ],
                        });
                        this.charts[1].chart = AmCharts.makeChart(this.charts[1].id, chartsSettings2);
                    },
                    updateItems: updatePriorities,
                    prepareCharts: function() {
                        prepareGraphs();
                        organizeItemsSelections(priorities, this.table.currentItems);
                    },
                    updateGraphs: function(graphKey, name, graphColor) {
                        var that = this;
                        $scope.directions.forEach(function(direction) {
                            addGraph(that.charts[0].chart, 'line', graphKey + 'egress' + direction.value, name + ' Throughput ' + direction.label,
                                graphKey + direction.value + '_egress', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, false, graphColor);
                            addGraph(that.charts[1].chart, 'column', graphKey + 'discarded' + direction.value, name + ' Discarded ' + direction.label,
                                graphKey + direction.value + '_discarded', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, false, graphColor);
                        });
                    },
                    removeGraphs: function(graphKey, name) {
                        var that = this;
                        $scope.directions.forEach(function(direction) {
                            removeGraph(that.charts[0].chart, graphKey + 'egress' + direction.value);
                            removeGraph(that.charts[1].chart, graphKey + 'discarded' + direction.value);
                        });
                    },
                    updateDataPoint: function(currentRatesDataPointStats, currentCurrentsDataPoint, newChartDataPoint, direction, inter) {
                        this.table.currentItems.forEach(function(priority) {
                            var pointKey = direction.value;
                            if ($scope.currentGraphsMode !== $scope.graph_modes.merged) {
                                pointKey = priority + '_' + pointKey;
                            }
                            var currentDataPointPriority = currentRatesDataPointStats[priority];
                            if (currentDataPointPriority) {
                                newChartDataPoint[pointKey + '_discarded'] = (newChartDataPoint[pointKey + '_discarded'] || 0) + ((currentDataPointPriority.discarded || 0) * direction.modifier);
                                newChartDataPoint[pointKey + '_egress'] = (newChartDataPoint[pointKey + '_egress'] || 0) + ((currentDataPointPriority.egress || 0) * direction.modifier);

                                if (newChartDataPoint[pointKey + '_egress'] === 0) {
                                    newChartDataPoint[pointKey + '_egress'] = 0.0001 * direction.modifier; // we can't have it on 0 or it might be glued to the other direction
                                }
                            }
                        });
                    },
                    table: angular.extend({
                        fields: [
                            { label: 'Priority', path: 'name', template: '<span>{{item.name}}</span>' },
                            { label: 'Class of Traffic', path: 'class', template: '<span>{{item.class}}</span>' },
                            { label: 'Hosts', template: '<div class="pie-wrapper"><div id="hosts-pie-{{item.id}}" class="tops-pie-chart" ng-click="tableConfig.stopPropagation($event)"></div></div>' },
                            { label: 'Apps', template: '<div class="pie-wrapper"><div id="apps-pie-{{item.id}}" class="tops-pie-chart" ng-click="tableConfig.stopPropagation($event)"></div></div>' },
                            { label: 'Throughput', path: 'throughput', template: '<div class="bar" id="bar-current-{{item.id}}">{{item.throughput || 0 | bits}}ps</div>' },
                            { label: 'Discarded', path: 'discarded', template: '<div class="bar" id="bar-discarded-{{item.id}}">{{item.discarded || 0 | bits}}ps</div>' },
                            { label: 'Pkt Loss', path: 'packetLossCalc', template: '<div class="bar mos" id="bar-packetLoss-{{item.id}}" data-toggle="tooltip" ng-attr-title="Up: {{(item.packetLossCalc.upstream || 0) | number:1}}%. Down: {{(item.packetLossCalc.downstream || 0) | number:1}}%" >{{(item.packetLossCalc.total || 0) | number:1}}%</div>' },
                            { label: 'MOS', path: 'mos', template: '<div class="bar mos" id="bar-mos-{{item.id}}" data-toggle="tooltip" ng-attr-title="Up: {{item.mos.upstream | number:1}}. Down: {{item.mos.downstream | number:1}}" >{{item.mos.total | number:1}}</div>' },
                        ],
                        type: 'Priorities',
                        tableItems: priorities,
                        titleSearch: 'QoS',
                        currentItems: [allItemsId],
                    }, commonViewTableSettings),
                },
                transports: {
                    interval: 1000,
                    order: 1,
                    title: 'Transport',
                    mergeTransports: false,
                    mergePriorities: true,
                    charts: [
                        { id: 'transportChart1', position: 'right', minxMax: true, order:0 },
                        { id: 'transportChart2', small: true, position: 'left', order:0 },
                        { id: 'transportChart3', small: true, position: 'right', minxMax: true , order:2},
                        { id: 'transportChart4', small: true, position: 'left', minxMax: true, order:1 },
                        { id: 'transportChart5', small: true, position: 'right', minxMax: true , order:1},
                    ],
                    statsCollection: 'linkQualityDataPoints',
                    currentsCollection: 'ratesDataPoints',
                    timeInterval: 5000,
                    drawCharts: function() {
                        var chartsSettings1 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-1', 'Throughput', function(value) {
                                    return $filter('bits')(Math.abs(value), 1) + 'ps';
                                }),
                                { id: 'ValueAxis-3', "gridAlpha": 0, "axisAlpha": 0, "stackType": "regular", "labelsEnabled": false }
                            ],
                        });

                        this.charts[0].chart = AmCharts.makeChart(this.charts[0].id, chartsSettings1);


                        var chartsSettings2 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-1', 'Distance', function(value) {
                                    return Math.abs(value) + 'ms';
                                }),
                            ],
                        });
                        this.charts[1].chart = AmCharts.makeChart(this.charts[1].id, chartsSettings2);

                        var chartsSettings3 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-2', 'Packet Loss', function(value) {
                                    return Math.abs(value) + '%';
                                }),
                                { id: 'ValueAxis-3', "gridAlpha": 0, "axisAlpha": 0, "stackType": "regular", "labelsEnabled": false }
                            ],
                        });
                        this.charts[2].chart = AmCharts.makeChart(this.charts[2].id, chartsSettings3);

                        var chartsSettings4 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-4', 'Jitter', function(value) {
                                    return Math.abs(value) + 'ms';
                                }),
                                { id: 'ValueAxis-3', "gridAlpha": 0, "axisAlpha": 0, "stackType": "regular", "labelsEnabled": false }
                            ],
                        });
                        this.charts[3].chart = AmCharts.makeChart(this.charts[3].id, chartsSettings4);

                        var chartsSettings5 = ChartsService.getCommonSerialChartSettings({
                            categoryAxis: {
                                gridCount: MAX_CHART_ITEMS_COUNT,
                            },
                            valueAxes: [
                                getValueAxis('ValueAxis-5', 'Discarded Packets', function (value) {
                                    return $filter('bits')(Math.abs(value), 1);
                                }),
                                { id: 'ValueAxis-3', "gridAlpha": 0, "axisAlpha": 0, "stackType": "regular", "labelsEnabled": false }
                            ],
                        });
                        this.charts[4].chart = AmCharts.makeChart(this.charts[4].id, chartsSettings5);
                    },
                    updateItems: updateTransports,
                    prepareCharts: function() {
                        prepareGraphs();
                        organizeItemsSelections(transports);
                    },
                    updateGraphs: function(graphKey, name, graphColor, destType, siteType) {
                        var that = this;
                        $scope.directions.forEach(function(direction) {
                            addGraph(that.charts[0].chart, 'line', graphKey + 'throughput' + direction.value, name + ' Throughput ' + direction.label,
                                graphKey + direction.value + '_throughput', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, false, graphColor);
                            if (!siteType || siteType === 'DTLS') {
                                addGraph(that.charts[2].chart, 'percentColumnGraph', graphKey + 'packet_loss_pct' + direction.value, name + ' Packet Loss ' + direction.label,
                                    graphKey + direction.value + '_packet_loss_pct', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, 'percent', graphColor);
                                addGraph(that.charts[3].chart, 'line', graphKey + 'jitter_ms' + direction.value, name + ' Jitter ' + direction.label,
                                    graphKey + direction.value + '_jitter_ms', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, 'time', graphColor);
                            } else {
                                $('#' + that.charts[2].id).addClass('not-implemented');
                                $('#' + that.charts[3].id).addClass('not-implemented');
                            }
                            addGraph(that.charts[4].chart, 'line', graphKey + 'discarded' + direction.value, name + ' Discarded ' + direction.label,
                                graphKey + direction.value + '_discarded', $scope.currentGraphsMode === $scope.graph_modes.stacked, direction, false, graphColor);
                        });
                        if (destType !== 'ALTERNATIVE' && destType !== 'LAYER_2_WAN') {
                            if (!siteType || siteType === 'DTLS' || siteType === 'IPSEC_HOST' || siteType === 'IPSEC_V2' || siteType === 'IPSEC_CLIENT') {
                                addGraph(that.charts[1].chart, 'line', graphKey + 'latency_ms', name + ' Distance', graphKey + 'latency_ms', $scope.currentGraphsMode === $scope.graph_modes.stacked,
                                    false, 'time', graphColor);
                            } else {
                                $('#' + that.charts[1].id).addClass('not-implemented');
                            }

                        }
                    },
                    removeGraphs: function(graphKey, name) {
                        var that = this;
                        $scope.directions.forEach(function(direction) {
                            removeGraph(that.charts[0].chart, graphKey + 'throughput' + direction.value);
                            removeGraph(that.charts[2].chart, graphKey + 'packet_loss_pct' + direction.value);
                            removeGraph(that.charts[3].chart, graphKey + 'jitter_ms' + direction.value);
                            removeGraph(that.charts[4].chart, graphKey + 'discarded' + direction.value);
                        });
                        removeGraph(that.charts[1].chart, graphKey + 'latency_ms');
                    },
                    updateDataPoint: function(currentRatesDataPointStats, currentCurrentsDataPoint, newChartDataPoint, direction, inter) {
                        var pointKey = '';
                        if ($scope.currentGraphsMode !== $scope.graph_modes.merged) {
                            pointKey = inter.interface_id + '_';
                        }

                        for (var statsKey in currentRatesDataPointStats) {
                            if (statsKey === 'latency_ms') { // latency doesn't have a direction
                                if (currentRatesDataPointStats[statsKey]) {
                                    if (newChartDataPoint[pointKey + statsKey]) {
                                        newChartDataPoint[pointKey + statsKey] = Math.max(newChartDataPoint[pointKey + statsKey], currentRatesDataPointStats[statsKey]);
                                    } else {
                                        newChartDataPoint[pointKey + statsKey] = currentRatesDataPointStats[statsKey];
                                    }
                                }
                            } else {
                                newChartDataPoint[pointKey + direction.value + '_' + statsKey] = Math.max(Math.abs(newChartDataPoint[pointKey + direction.value + '_' + statsKey] || 0), Math.abs((currentRatesDataPointStats[statsKey] || 0)))  * direction.modifier;
                            }
                        }

                        if (currentCurrentsDataPoint && currentCurrentsDataPoint.stats && currentCurrentsDataPoint.stats[allItemsId]) {
                            // we use the egress and discarded from priority -1 (which includes all data) for the throughput and discarded of an interface
                            newChartDataPoint[pointKey + direction.value + '_throughput'] = (newChartDataPoint[pointKey + direction.value + '_throughput'] || 0) + ((currentCurrentsDataPoint.stats[allItemsId].egress || 0) * direction.modifier);
                            newChartDataPoint[pointKey + direction.value + '_discarded'] = (newChartDataPoint[pointKey + direction.value + '_discarded'] || 0) + ((currentCurrentsDataPoint.stats[allItemsId].discarded || 0) * direction.modifier);
                            if (newChartDataPoint[pointKey + direction.value + '_throughput'] === 0) {
                                newChartDataPoint[pointKey + direction.value + '_throughput'] = 0.0001 * direction.modifier;
                            }
                        }
                    },
                    table: angular.extend({
                        fields: [
                            { label: 'Name', path: 'label', template: '<span>{{item.name || item.interface_id}}</span>' },
                            { label: 'Type', path: 'type', template: '<span>{{item.destType}}</span>' },
                            { label: 'Hosts', template: '<div class="pie-wrapper"><div id="hosts-pie-{{item.id}}" class="tops-pie-chart" ng-click="tableConfig.stopPropagation($event)"></div></div>' },
                            { label: 'Apps', template: '<div class="pie-wrapper"><div id="apps-pie-{{item.id}}" class="tops-pie-chart" ng-click="tableConfig.stopPropagation($event)"></div></div>' },
                            { label: 'Throughput', path: 'throughput', template: '<div class="bar" id="bar-current-{{item.id}}">{{item.throughput || 0 | bits}}ps</div>' },
                            { label: 'Discarded', path: 'discarded', template: '<div class="bar" id="bar-discarded-{{item.id}}">{{item.discarded || 0 | bits}}ps</div>' },
                            { label: 'Jitter', path: 'jitter', template: '<span ng-show="item.type === \'DTLS\'">{{item.jitter || 0}}ms</span><span ng-show="item.type !== \'DTLS\'" class="cato-tooltip" data-type="INFORMATION" data-title="This data in not available when using this connection type">N/A</span>' },
                            { label: 'Pkt Loss', path: 'packetLoss', template: '<span ng-show="item.type === \'DTLS\'">{{item.packetLoss || 0}}%</span><span ng-show="item.type !== \'DTLS\'" class="cato-tooltip" data-type="INFORMATION" data-title="This data in not available when using this connection type">N/A</span>' },
                            { label: 'Distance', path: 'latency', template: '<span ng-show="tableConfig.showLatency(item)">{{item.latency || 0}}ms</span><span ng-show="!tableConfig.showLatency(item) && item.destType !== \'ALTERNATIVE\' && item.destType !== \'LAYER_2_WAN\'" class="cato-tooltip" data-type="INFORMATION" data-title="This data in not available when using this connection type">N/A</span><span ng-show="item.destType === \'ALTERNATIVE\' || item.destType === \'LAYER_2_WAN\'" class="cato-tooltip" data-type="INFORMATION" data-title="This value is not available for Alt. WAN">N/A</span>' },
                        ],
                        showLatency: function(item) {
                            return (!item.type || item.type === 'DTLS' || item.type === 'IPSEC_HOST' || item.type === 'IPSEC_V2' ||
                                item.type === 'IPSEC_CLIENT') && item.destType !== 'ALTERNATIVE' && item.destType !== 'LAYER_2_WAN';
                        },
                        type: 'Transports',
                        titleSearch: 'Transports',
                        tableItems: transports,
                        currentItems: [allItemsId],
                    }, commonViewTableSettings),
                },
            };


            function getTransports(callback) {
                store.fetch({
                    path: '/getTransports?accountId=' + $state.params.accountId + '&pid=' + $scope.pid,
                    success: function(data) {
                        $timeout(function() {
                            if ($scope.destroyed) {
                                return;
                            }
                            if (data && !data.status) {
                                data.forEach(function(transport) {
                                    transport.selected = true;
                                    transport.id = transport.interface_id; // we use the id as a general selector, but want the interface_id in this case because it's the identifier in the stats
                                    if (transport.type === 'CROSS_CONNECT_VRF') {
                                        transport.name = 'Cross-Connect';
                                        transport.destType = 'VRF';
                                    } else if (transport.type === 'CROSS_CONNECT_L2') {
                                        transport.name = 'Cross-Connect';
                                        transport.destType = 'Layer 2';
                                    }
                                    transports.push(transport);
                                });

                                if (transports.length > 0) {
                                    transports.sort(function(a, b) {
                                        if (a.name < b.name) { return -1; } else if (a.name > b.name) { return 1; } else return 0;
                                    });
                                }

                                if (callback) {
                                    callback();
                                }
                            }
                        }, 0);
                    }
                });
            }

            function getPriorities(callback) {
                store.fetch({
                    path: '/getPriorities?accountId=' + $state.params.accountId,
                    success: function(data) {
                        if ($scope.destroyed) {
                            return;
                        }
                        if (data && data.items) {
                            data.items.forEach(function(policy) {
                                priorities.push({
                                    name: 'P' + policy.name,
                                    id: parseInt(policy.name),
                                    class: policy.description,
                                    selected: true,
                                });
                            });
                            if (priorities.length > 0) {
                                priorities.sort(function(a, b) {
                                    if (a.id < b.id) { return -1; } else if (a.id > b.id) { return 1; } else return 0;
                                });
                            }

                            if (callback) {
                                callback();
                            }
                        }
                    }
                });
            }

            function mergeData(oldData, newData) {
                oldData.rules = newData.rules;
                if (!newData.interfaces) {
                    return;
                }
                for (var inter in newData.interfaces) {
                    if (oldData.interfaces[inter]) {
                        $scope.directions.forEach(function(direction) {
                            if (newData.interfaces[inter][direction.value]) {
                                if (oldData.interfaces[inter][direction.value]) {
                                    var oldDataDir = oldData.interfaces[inter][direction.value];
                                    var newDataDir = newData.interfaces[inter][direction.value];

                                    oldDataDir.priorities = newDataDir.priorities;
                                    oldDataDir.bandwidth = newDataDir.bandwidth;

                                    var colKeys = ['linkQualityDataPoints', 'ratesDataPoints'];

                                    colKeys.forEach(function(colKey) {
                                        if (newDataDir[colKey]) {
                                            if (oldDataDir[colKey] && oldDataDir[colKey].length > 0) {
                                                var lastTimeStampInOldData = oldDataDir[colKey][oldDataDir[colKey].length - 1].timestamp;
                                                newDataDir[colKey].forEach(function(newDataPoint) {
                                                    if (!lastTimeStampInOldData || newDataPoint.timestamp > lastTimeStampInOldData) {
                                                        oldDataDir[colKey].push(newDataPoint);
                                                    }
                                                });
                                            } else {
                                                oldDataDir[colKey] = newDataDir[colKey];
                                            }
                                        }

                                        if (oldDataDir[colKey]) {
                                            var itemsToCut = oldDataDir[colKey].length - MAX_DATA_COLLECTIONS_SIZE;
                                            if (itemsToCut > 0) {
                                                oldDataDir[colKey] = oldDataDir[colKey].slice(itemsToCut);
                                            }
                                        }
                                    });
                                } else {
                                    oldData.interfaces[inter][direction.value] = newData.interfaces[inter][direction.value];
                                }
                            }
                        });
                    }
                }
            }

            function getRT() {
                if (stop) {
                    return;
                }

                store.fetch({
                    path: '/getTransientRealTimeData/quality?accountId=' + $state.params.accountId + '&account=' + $state.params.accountId + '&pid=' + $scope.pid,
                    success: function(data) {
                        if ($scope.destroyed) {
                            return;
                        }
                        if (data) {
                            var $notificationsEl = $('.ngn');
                            if (data.status && data.status === 'ERROR') {
                                if ($notificationsEl.css('display') !== 'block') {
                                    $scope.$root.showNotification('error', data.notifications[0].message, data.notifications[0].message, true, true);
                                }
                            } else {
                                if ($notificationsEl.css('display') == 'block') {
                                    $scope.$root.hideNotification();
                                }

                                if (allData) {
                                    mergeData(allData, data);
                                } else {
                                    allData = data;
                                }

                                if (!globalDate) {
                                    setInitialsChartData();
                                    globalDate = data.newestTimeStamp;
                                    //console.log("globalDate: " + new Date(globalDate));
                                }

                                //until the first time actual data is coming from server we will show loading screen.
                                //actual data should have timestamp set.
                                if(data.newestTimeStamp != 0) {
                                    if($scope.innerLoader == true) {
                                        $scope.innerLoader = false;
                                    }
                                }

                                if (firstRequest) {
                                    $timeout(function() {
                                        runData();
                                        setRules();
                                        firstRequest = false;
                                    }, 0);
                                } else {
                                    if (updateSystemInfoCounter === 0) {
                                        updateSystemInfoCounter = 100;

                                        $timeout(function() {
                                            setRules();
                                        }, 0, false);
                                    }
                                    updateSystemInfoCounter--;
                                }
                            }
                        } else {
                            $timeout(function() {
                                // getRT();
                            }, 50, false);

                            return;
                        }
                    }
                });
            }

            function setRules() {
                $scope.rules = allData.rules;
            }

            function setInitialsChartData() {
                var newDate = (globalDate || new Date().getTime()) - TIME_DELAY;
                newDate = newDate - (newDate % 1000);

                newDate = newDate - (1000 * MAX_CHART_ITEMS_COUNT) - (newDate % 1000);
                while (chartData.length < MAX_CHART_ITEMS_COUNT) {
                    chartData.push({
                        timestamp: newDate,
                    });
                    newDate = newDate + 1000;
                }

                currentTimestamp = newDate; // settting initial currentTimeStamp
                //console.log(currentTimestamp);
            }

            function runData() {
                if ($scope.destroyed) {
                    return;
                }
                if (!$scope.paused && allData && $scope.currentView) {
                    if (dataStatus === 'SET') {
                        dataStatus = 'READY';
                        chartData.forEach(function(chartDataPoint) {
                            addChartItem(chartDataPoint.timestamp, chartDataPoint);
                        });
                        shouldUpdateView = true;
                    } else if (globalDate) {
                        // check the former date of when we ran data to now, to see how much time have passed and add to globalDate
                        if (formerDate) {
                            var newDate = new Date().getTime();
                            var ticksDiff = ((newDate-(newDate% $scope.currentView.interval)) - (formerDate-(formerDate% $scope.currentView.interval)))/ $scope.currentView.interval;
                            globalDate += ($scope.currentView.interval * ticksDiff);
                        }
                        formerDate = new Date().getTime();
                        var targetDate = globalDate - TIME_DELAY - (globalDate % $scope.currentView.interval);
                        //console.log("target: " + new Date(targetDate));

                        // clean old chart items (older than chart should hold, by date, not count) in case we have really old data compared to new date
                        if (chartData.length > 2 && (chartData[0].timestamp + ((MAX_CHART_ITEMS_COUNT + 10) * $scope.currentView.interval)) < targetDate) {
                            console.log("delayed!. Resetting. targetDate: " + targetDate);
                            chartData = [];
                            currentTimestamp = null;
                            dataStatus = 'SET';
                            setInitialsChartData();
                        }

                        if (currentTimestamp) {
                            var currentDate = new Date(globalDate);

                            if (currentTimestamp + ($scope.currentView.interval * 30) < currentDate.getTime()) {
                                console.log("delayed above 30 intervals. Resetting. current date: " + currentDate.getTime());
                                currentTimestamp = null;
                                runData();
                                return;
                            }

                            var newDateToAdd = currentTimestamp;

                            var itemsToAdd = (targetDate - currentTimestamp) / $scope.currentView.interval;
                            var itemsAdded = 0;

                            //console.log(itemsToAdd + " items to add");
                            for (var i = 0; i < itemsToAdd; i++) {
                                //console.log("delayed, " + newDate + " " + new Date(newDate));
                                if (addChartItem(newDateToAdd)) { itemsAdded++; } else {}
                                newDateToAdd += $scope.currentView.interval;
                            }
                            //console.log(itemsAdded + " items added");
                        } else {
                            addChartItem(targetDate);
                        }

                        shouldUpdateView = true;
                    }
                }

                runTimeout = $timeout(function() {
                    runData();
                }, 1000);
            }

            // add a data point to the chart or update an existing one
            function addChartItem(timestamp, chartDataPoint, noCurrentTimeStampUpdate) {
                var newChartDataPoint;
                transports.forEach(function(inter) {
                    if ($scope.currentView.mergeTransports || inter.selected) {
                        $scope.directions.forEach(function(direction) {
                            var currentDataPoint = getCurrentDataPoint(timestamp, inter.interface_id, direction.value, noCurrentTimeStampUpdate);
                            var currentCurrentsDataPoint;
                            if ($scope.currentView.currentsCollection !== $scope.currentView.statsCollection) {
                                if (allData.interfaces[inter.interface_id] && allData.interfaces[inter.interface_id][direction.value]) {
                                    currentCurrentsDataPoint = allData.interfaces[inter.interface_id][direction.value][$scope.currentView.currentsCollection].filter(
                                        function(item) { return item.timestamp >= (timestamp || currentTimestamp) + $scope.currentView.interval; })[0];
                                }
                            }

                            if (currentDataPoint || currentCurrentsDataPoint) {
                                if (dataStatus === 'NOT_SET') {
                                    dataStatus = 'SET';
                                }

                                newChartDataPoint = chartDataPoint || newChartDataPoint || {timestamp: timestamp};

                                var currentRatesDataPointStats = currentDataPoint ? currentDataPoint.stats : {};
                                $scope.currentView.updateDataPoint(currentRatesDataPointStats, currentCurrentsDataPoint, newChartDataPoint, direction, inter);
                            }
                        });
                    }
                });

                if (!newChartDataPoint) {
                    //console.log("data not found for timestamp " + timestamp + " " + new Date(timestamp));
                    return;
                }

                if (!chartDataPoint) { // in case it's not an update, add to chart data array
                    chartData.push(newChartDataPoint);
                    if (!noCurrentTimeStampUpdate) {
                        currentTimestamp = timestamp; // updating our current timestamp to see what is the last timestamp we've updated
                    }
                    if (chartData.length > MAX_CHART_ITEMS_COUNT - 1) {
                        chartData = chartData.slice(1);
                    }
                }
            }

            function getCurrentDataPoint(timestamp, inter, direction) {
                if (allData && allData.interfaces[inter] && allData.interfaces[inter][direction]) {
                    var newRelevantData = allData.interfaces[inter][direction];
                    var newerData = newRelevantData[$scope.currentView.statsCollection].filter(function(item) { return item.timestamp >= (timestamp || currentTimestamp) + $scope.currentView.interval; });
                    if (newerData.length > 0) {
                        return newerData[0];
                    }
                }
            }

            function addGraph(chart, type, id, title, valueField, stackable, direction, balloonType, graphColor) {
                if (!graphs[id]) {
                    graphs[id] = new AmCharts.AmGraph();
                    var options = angular.extend({
                        id: id,
                        title: title,
                        valueField: valueField,
                        stackable: stackable || false,
                        fillAlphas: stackable ? 1 : 0.1,
                        lineColor: graphColor ? graphColor : MERGED_LINE_COLOR,
                    }, type === 'line' ? angular.copy(ChartsService.getCommonLineGraph()) : angular.copy(ChartsService.getCommonColumnGraph()));

                    // for downstream we use a different value axis when stacking graphs, so graphs won't stack between directions
                    if (stackable) {
                        if (direction && direction.value === 'downstream') {
                            options.valueAxis = 'ValueAxis-3';
                        }
                    }
                    if (balloonType) {
                        if (balloonType === 'time') {
                            options.balloonFunction = function(graphDataItem) {
                                return Math.abs(graphDataItem.values.value) + 'ms';
                            };
                        } else if (balloonType === 'percent') {
                            options.balloonFunction = function(graphDataItem) {
                                return Math.abs(graphDataItem.values.value) + '%';
                            };
                        }
                    }

                    for (var optionsKey in options) {
                        graphs[id][optionsKey] = options[optionsKey];
                    }

                    chart.addGraph(graphs[id]);
                } else {
                    //console.log('duplicate graph ' + id);
                }
            }

            function removeGraph(chart, id) {
                if (graphs[id]) {
                    chart.removeGraph(graphs[id]);
                    graphs[id] = null;
                    delete graphs[id];
                }
            }

            function drawCharts() {
                $scope.currentView.drawCharts();
            }

            function drawTopCharts(colletion, type, charts) {
                colletion.forEach(function(item) {
                    var newChart = {
                        data: item,
                        chart: AmCharts.makeChart(type + '-pie-' + item.id, ChartsService.getCommonPieChartSettings()),
                    };

                    newChart.chart.addListener("rollOverSlice", function(event) {
                        if ($topsBalloon.length === 0) {
                            $topsBalloon = $("#tops-balloon");
                        }
                        $topsBalloon.html('<b>' + event.dataItem.title + ': ' + $filter('bits')(event.dataItem.value) + 'ps</b>');
                        $topsBalloon.show();
                    });

                    newChart.chart.addListener("rollOutSlice", function() {
                        if ($topsBalloon.length === 0) {
                            $topsBalloon = $("#tops-balloon");
                        }
                        $topsBalloon.hide();
                    });

                    charts.push(newChart);
                });
            }

            function updateCharts() {
                for (var chartKey in $scope.currentView.charts) {
                    var chart = $scope.currentView.charts[chartKey];
                    if (chart.chart) {
                        ChartsService.updateChart(chart.chart, chartData, {setAxiScale:chart.minxMax, stack: $scope.currentGraphsMode === $scope.graph_modes.stacked});
                    }
                }
            }

            function getValueAxis(id, title, labelFunction) {
                return ChartsService.getCommonValueAxis({
                    id: id,
                    title: title,
                    labelFunction: labelFunction,
                });
            }

            function prepareGraphs() {
                $scope.currentView.charts.forEach(function(chart) {
                    chart.chart.valueAxes.forEach(function(valueAxi) {
                        if (chart.minxMax && $scope.currentGraphsMode === $scope.graph_modes.stacked) {
                            valueAxi.stackType = 'regular';
                        } else {
                            valueAxi.stackType = 'none';
                        }
                    });
                });
            }

            // each time the view changes (view types or graph type was changed) we organize the colors if needed
            function organizeItemsSelections(items) {
                if ($scope.currentGraphsMode === $scope.graph_modes.merged) {
                    items.forEach(function(item) {
                        if (item.selected) {
                            item.color = MERGED_LINE_COLOR;
                        }
                    });
                    usedGraphsColors.length = 0;

                    var type;
                    if (items && items.length > 0) {
                        type = items[0].type;
                    }
                    $scope.currentView.updateGraphs('', '', null, null, type);
                } else {
                    if ($scope.currentView.table.currentItems.length === 1 && $scope.currentView.table.currentItems[0] === -1) {
                        $scope.currentView.table.currentItems.length = 0;
                    }
                    $scope.currentView.removeGraphs('-1_');

                    var counter = 0;
                    items.forEach(function(item) {
                        if (counter < MAX_SEPARATED_GRAPHS && item.selected) {
                            if (item.color === MERGED_LINE_COLOR || !item.color) {
                                item.color = getItemColor(item);
                            }
                            $scope.currentView.updateGraphs(item.id + '_', item.name, item.color, item ? item.destType : null, item ? item.type : null);
                            if ($scope.currentView.table.currentItems.indexOf(item.id) < 0) {
                                $scope.currentView.table.currentItems.push(item.id);
                            }
                            counter++;
                        } else {
                            unSelectItem(item);
                        }
                    });
                }
            }

            function unSelectItem(item) {
                if (item.color) {
                    // mark item color as available for selection
                    var colorIndex = usedGraphsColors.indexOf(item.color);
                    if (colorIndex > -1) {
                        usedGraphsColors.splice(colorIndex, 1);
                    }
                }
                item.selected = false;
                item.color = null;
                $scope.currentView.removeGraphs(item.id + '_');
                if ($scope.currentView.table.currentItems.indexOf(item.id) >= 0) {
                    $scope.currentView.table.currentItems.splice($scope.currentView.table.currentItems.indexOf(item.id), 1);
                }
            }

            function mergeTopList(oldTopList, newTopList) {
                if (!oldTopList || oldTopList.length === 0) {
                    return angular.copy(newTopList);
                }


                newTopList.forEach(function(newItem) {
                    if (!newItem.name || newItem.name === '') {
                        newItem.name = newItem.host_ip;
                    }

                    var oldItem = oldTopList.filter(function(item) { return item.name === newItem.name; })[0];
                    if (oldItem) {
                        oldItem.throughput += newItem.throughput;
                    } else {
                        oldTopList.push(newItem);
                    }
                });

                oldTopList.sort(function(a, b) {
                    if (a.throughput < b.throughput) { return 1; } else if (a.throughput > b.throughput) { return -1; } else return 0;
                });

                if (oldTopList.length > MAX_TOPS_TO_SHOW) {
                    oldTopList.splice(MAX_TOPS_TO_SHOW);
                }

                return oldTopList;
            }

            function updateView() {
                cleanCurrents();
                setCurrents();
                fillBars();

                $scope.currentView.table.tableItems.forEach(function(item) {
                    item.mos = { upstream: 0, downstream: 0, total: 0 };
                    item.packetLossCalc = { upstream: 0, downstream: 0, total: 0 };
                    var priorityDatas = [];
                    $scope.directions.forEach(function(direction) {
                        if ($scope.currentView.mergeTransports) {
                            var directionThroughput = 0; // total throughput of current
                            transports.forEach(function(inter) {
                                if (allData.interfaces[inter.interface_id]) {
                                    var newRelevantData = allData.interfaces[inter.interface_id][direction.value];

                                    var thisPriorityData = newRelevantData.priorities.filter(function(prioItem) { return prioItem.priority === item.id; })[0];
                                    if (thisPriorityData) {
                                        setPrioritySystemInfo(item, thisPriorityData, direction.value, inter.interface_id);
                                        item.mos[direction.value] += thisPriorityData.mos * thisPriorityData.current_rates.egress;
                                        item.packetLossCalc[direction.value] += thisPriorityData.packet_loss_pct * thisPriorityData.current_rates.egress;
                                        directionThroughput += thisPriorityData.current_rates.egress;
                                        priorityDatas.push(thisPriorityData);
                                    }
                                }
                            });
                            item.mos[direction.value] = directionThroughput == 0 ? 0 : (item.mos[direction.value] / directionThroughput); // mos is calcaulated by average of direction, and weighted average of interfaces
                            item.packetLossCalc[direction.value] = directionThroughput == 0 ? 0 : (item.packetLossCalc[direction.value] / directionThroughput); // packetloss is calcaulated by average of direction, and weighted average of interfaces
                        } else {
                            if (allData.interfaces[item.interface_id]) {
                                var newRelevantData = allData.interfaces[item.interface_id][direction.value];

                                var thisPriorityData = newRelevantData.priorities.filter(function(prioItem) { return prioItem.priority === allItemsId; })[0];
                                if (thisPriorityData) {
                                    priorityDatas.push(thisPriorityData);
                                }
                            }
                        }
                    });

                    calculateAverageOfDirections(item, 'mos');
                    calculateAverageOfDirections(item, 'packetLossCalc');

                    var updatedListTimeStamp = item.topsTimestamp || 0;
                    var newTopHosts = [];
                    var newTopApps = [];
                    priorityDatas.forEach(function(newPriorityData) {
                        if (newPriorityData.top_src && newPriorityData.top_src.top_n) {
                            newTopHosts = mergeTopList(newTopHosts, newPriorityData.top_src.top_n);
                            newTopApps = mergeTopList(newTopApps, newPriorityData.top_target.top_n);
                            updatedListTimeStamp = Math.max(newPriorityData.top_src.timestamp, updatedListTimeStamp);
                        }
                    });

                    // we want to minimize updating the tops charts because it's costly
                    if (item.topsTimestamp !== updatedListTimeStamp) {
                        item.topsTimestamp = updatedListTimeStamp;
                        item.topHosts = newTopHosts;
                        item.topApps = newTopApps;
                        updateTopsCharts(item);
                    }

                });

                updateCharts();

                $timeout(function() {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 0, false);
            }

            // set total value (average of directions) of sent varKey on item
            function calculateAverageOfDirections(item, varKey) {
                if (item[varKey].upstream === 0) {
                    item[varKey].total = item[varKey].downstream;
                }
                else if (item[varKey].downstream === 0) {
                    item[varKey].total = item[varKey].upstream;
                }
                else {
                    item[varKey].total = (item[varKey].upstream + item[varKey].downstream) / 2;
                }
            }

            function cleanCurrents() {
                $scope.currentData = {};

                priorities.forEach(function(priority) {
                    priority.throughput = 0;
                    priority.discarded = 0;
                    priority.queued = 0;
                    priority.mos = 0;
                    priority.mosUp = 0;
                    priority.mosDown = 0;
                });

                transports.forEach(function(inter) {
                    inter.throughput = 0;
                    inter.discarded = 0;
                    inter.queued = 0;
                    inter.jitter = 0;
                    inter.latency = 0;
                    inter.packetLoss = 0;
                });
            }

            // set the viewed items 'currents' values
            function setCurrents() {
                $scope.directions.forEach(function(direction) {
                    var currents = {throughput: 0, discarded: 0, queued: 0, bandwidth: 0};
                    transports.forEach(function(inter) {
                        if (allData && allData.interfaces[inter.interface_id] && allData.interfaces[inter.interface_id][direction.value]) {
                            var newRelevantData = allData.interfaces[inter.interface_id][direction.value];
                            $scope.currentView.updateItems(newRelevantData, inter, currents);
                            if (newRelevantData.bandwidth) {
                                currents.bandwidth += newRelevantData.bandwidth;
                            }
                        }
                    });
                    $scope.currentData[direction.value] = currents;
                });
            }

            function fillBars() {
                var maxEgress = $scope.currentView.table.tableItems.reduce(function(currentMax, prio) { return Math.max(Math.max(prio.throughput, prio.discarded), currentMax)}, 0);
                $scope.currentView.table.tableItems.forEach(function(prio) {
                    var gradientPercentCurrent = !prio.throughput ? 0 : ((prio.throughput / maxEgress) * 100);
                    $('#bar-current-' + prio.id).css('background', 'linear-gradient(90deg, #158864, white ' + gradientPercentCurrent + '%)');
                    var gradientPercentDiscarded = !prio.discarded ? 0 : ((prio.discarded / maxEgress) * 150);
                    $('#bar-discarded-' + prio.id).css('background', 'linear-gradient(90deg, #ff7336, white ' + gradientPercentDiscarded + '%)');
                });
            }

            function getCurrentFromCollection(collectionToSearch) {
                var foundCol = collectionToSearch.filter(function(item) { return item.timestamp <= currentTimestamp && item.timestamp >= currentTimestamp - ($scope.currentView.timeInterval || $scope.currentView.interval); });
                return foundCol[foundCol.length - 1];
            }

            function updateTransports(newRelevantData, inter, updatedCurrents) {
                var interfaceData;
                var currStats = getCurrentFromCollection(newRelevantData[$scope.currentView.currentsCollection]);
                if (currStats) {
                    interfaceData = currStats.stats[allItemsId];
                    if (interfaceData) {
                        inter.throughput += interfaceData.egress || 0;
                        updatedCurrents.throughput += interfaceData.egress || 0;
                        inter.discarded += interfaceData.discarded || 0;
                        updatedCurrents.discarded += interfaceData.discarded || 0;
                        inter.queued += interfaceData.queued || 0;
                        updatedCurrents.queued += interfaceData.queued || 0;
                    } else {
                        inter.throughput = 0;
                        inter.discarded = 0;
                        inter.queued = 0;
                    }
                }

                currStats = getCurrentFromCollection(newRelevantData[$scope.currentView.statsCollection]);
                if (currStats) {
                    interfaceData = currStats.stats;
                    if (interfaceData) {
                        inter.jitter = Math.max(inter.jitter || 0, interfaceData.jitter_ms || 0);
                        inter.latency = Math.max(inter.latency || 0, interfaceData.latency_ms || 0);
                        inter.packetLoss = Math.max(inter.packetLoss || 0, interfaceData.packet_loss_pct || 0);
                    } else {
                        inter.jitter = 0;
                        inter.latency = 0;
                        inter.packetLoss = 0;
                    }
                }

                return inter;
            }

            function updatePriorities(newRelevantData, inter, updatedCurrents) {
                priorities.forEach(function(priority) {
                    var curr = getCurrentFromCollection(newRelevantData[$scope.currentView.currentsCollection]);
                    if (curr) {
                        var priorityStats = curr.stats[priority.id];
                        if (priorityStats) {
                            priority.throughput += priorityStats.egress || 0;
                            updatedCurrents.throughput += priorityStats.egress || 0;
                            priority.discarded += priorityStats.discarded || 0;
                            updatedCurrents.discarded += priorityStats.discarded || 0;
                            priority.queued += priorityStats.queued || 0;
                            updatedCurrents.queued += priorityStats.queued || 0;
                        } else {
                            priority.throughput = 0;
                            priority.discarded = 0;
                            priority.queued = 0;
                        }
                    }
                });
            }

            function updateTopsCharts(priority) {
                hostsCharts.forEach(function(chart) {
                    if (chart.data.id === priority.id) {
                        chart.chart.dataProvider = priority.topHosts;
                        chart.chart.validateData();
                    }
                });

                appsCharts.forEach(function(chart) {
                    if (chart.data.id === priority.id) {
                        chart.chart.dataProvider = priority.topApps;
                        chart.chart.validateData();
                    }
                });
            }

            function clearSettings() {
                clearChartsArray(hostsCharts);
                clearChartsArray(appsCharts);

                for (var g in graphs) {
                    graphs[g] = null;
                }
                graphs = [];

                if ($scope.currentView) {
                    $scope.currentView.charts.forEach(function(chart) {
                        if (chart.chart) {
                            chart.chart.clear();
                            chart.chart = null;
                        }
                    });
                }

                if (runTimeout) {
                    //$timeout.cancel(runTimeout);
                    runTimeout = null;
                }

                usedGraphsColors = [];
            }

            function clearChartsArray(chartsArray) {
                if (chartsArray) {
                    chartsArray.forEach(function(chart) {
                        chart.chart.clear();
                        chart.chart = null;
                        chart = null;
                    });
                    chartsArray.length = 0;
                }
            }

            function getItemColor(item) {
                var itemColor;

                if (item.color) {
                    if (usedGraphsColors.indexOf(item.color) > -1) {
                        // color in used, can't keep it
                        item.color = null;
                    }
                    if (item.color === MERGED_LINE_COLOR) {
                        item.color = null;
                    }
                }

                if (!item.color) {
                    // assigning a free graph color to the item, to be used in graphs relating to it (and legend)
                    for (var i = 0; i < GRAPHS_COLORS.length; i++) {
                        var graphColor = GRAPHS_COLORS[i];
                        if (usedGraphsColors.indexOf(graphColor) === -1) {
                            itemColor = graphColor;
                            usedGraphsColors.push(graphColor);
                            break;
                        }
                    }
                }

                return itemColor;
            }

            function setPrioritySystemInfo(item, priorityData, direction, inter) {
                if (priorityData.counters) {
                    if (!item.system) {
                        item.system = {};
                    }
                    for (var countKey in priorityData.counters) {
                        if (!item.system[countKey]) {
                            item.system[countKey] = {};
                        }
                        if (!item.system[countKey][direction]) {
                            item.system[countKey][direction] = {};
                        }
                        item.system[countKey][direction][inter] = priorityData.counters[countKey];
                    }

                    if (!item.system.max_delay_ms) {
                        item.system.max_delay_ms = {};
                    }
                    if (!item.system.max_delay_ms[direction]) {
                        item.system.max_delay_ms[direction] = {};
                    }
                    item.system.max_delay_ms[direction][inter] = priorityData.max_delay_ms;


                    if (!item.system.queued_items) {
                        item.system.queued_items = {};
                    }
                    if (!item.system.queued_items[direction]) {
                        item.system.queued_items[direction] = {};
                    }
                    item.system.queued_items[direction][inter] = priorityData.queued_items;

                }
            }

            // make view changes by clearing current charts and resetting data, then update view
            function changeView() {
                dataStatus = 'SET';
                chartData = [];
                currentTimestamp = null;
                setInitialsChartData();
                shouldUpdateView = true;
            }

            // change between the graphs mode (stacked/compare...)
            $scope.changeGraphsMode = function(newType) {
                $timeout(function() {
                    for (var g in graphs) {
                        graphs[g].chart.removeGraph(graphs[g]);
                        graphs[g] = null;
                    }
                    graphs = [];
                    $scope.currentGraphsMode = newType;
                    $scope.currentView.prepareCharts();
                    changeView();
                }, 0);
            };

            // change between the view types (transports/priorities...)
            $scope.changeViewType = function(newView) {
                clearSettings();
                $scope.currentView = newView;
                $timeout(function() {
                    $scope.paused = false;
                    drawCharts();
                    $scope.currentView.prepareCharts();
                    changeView();
                }, 0);
            };

            $scope.togglePause = function() {
                $scope.paused = !$scope.paused;

                if (!$scope.paused) {
                    changeView();
                }
            };

            function init() {
                $topsBalloon = $("#tops-balloon");
                IntervalService.dynamicInterval(getRT,$scope.$id, 'monitorRealTimeGetRt',false);
                getPriorities();
                getTransports(function() {
                    if (!$scope.currentView) {
                        $scope.changeViewType($scope.views.transports);
                    }
                }); // get transports and then show the transports view

                updateViewLoop  = $interval(function() {
                    if (shouldUpdateView) {
                        updateView();
                        shouldUpdateView = false;
                    }
                }, 100, false);

                handleVisibilityChange = function() {
                    if (!$scope.loaded) {
                        return;
                    }
                    if (!document.hidden) {
                        changeView();
                    }
                };

                document.addEventListener("visibilitychange", handleVisibilityChange, false);


                $thisElement = $($element);
                $thisElement.on('mousemove', '.tops-pie-chart', function(event) {
                    if ($topsBalloon.length === 0) {
                        $topsBalloon = $("#tops-balloon");
                    }
                    var targetPosition = $(event.toElement).offset();
                    var targetPosition2 = $(event.currentTarget).position();
                    $topsBalloon.css({
                        top: targetPosition2.top + (targetPosition.top - targetPosition2.top) - 50,
                        left: targetPosition2.left,
                    });
                });
                $thisElement.on('mouseout', '.tops-pie-chart', function(event) {
                    if ($topsBalloon.length === 0) {
                        $topsBalloon = $("#tops-balloon");
                    }
                    $topsBalloon.hide();
                });
            }


            init();

            // for interval use
            window.stopUpdate = function() {
                stop = !stop;
            };

            $scope.$on('$destroy', function() {
                if (handleVisibilityChange) {
                    document.removeEventListener("visibilitychange", handleVisibilityChange, false);
                }
                $scope.loaded = false;
                $scope.destroyed = true;
                stop = true;
                $scope.$root.realtime = false;

                IntervalService.cancelDynamicInterval($scope.$id, 'monitorRealTimeGetRt');

                if (runTimeout) {
                    $timeout.cancel(runTimeout);
                }

                if (updateViewLoop) {
                    $interval.cancel(updateViewLoop);
                }
                delete window.stopUpdate;

                if ($thisElement) {
                    $thisElement.off('mousemove');
                    $thisElement.off('mouseout');
                }

                GeneralUtilsService.cleanAmChartsFromScope($element);
            });
        }]
    }
});
